import { LazyAction, LazyModule, LazyImport } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "GroupHeaderActions" */ './lazyIndex');
});
export var lazySetGroupHeaderCallbacks = new LazyAction(lazyModule, function (m) { return m.setGroupHeaderCallbacks; });
export var lazyGroupHeaderCommandBarStore = new LazyImport(lazyModule, function (m) { return m.groupHeaderCommandBarStore; });
export var lazyGroupHeaderNavigationButton = new LazyImport(lazyModule, function (m) { return m.groupHeaderNavigationButton; });
export var lazyGroupHeaderCommandBarAction = new LazyAction(lazyModule, function (m) { return m.groupHeaderCommandBarAction; });
//# sourceMappingURL=index.js.map